import { Text } from 'src/components/Text/Text'

import styles from './SubmissionNotice.module.css'

// Router state passed by ContractReport after a successful KPI submission.
// The dashboard and the programme page both read it via readReportSubmitted().
type ReportSubmittedState = {
  reportSubmitted: {
    contract: string
    period: string
  }
  programmeNeedsAttention?: boolean
}

type ReportSubmitted = {
  contract: string
  period: string
  programmeNeedsAttention: boolean
}

// location.state is untyped and may hold anything (or nothing) — guard it so a
// missing or foreign state can never crash the page.
function readReportSubmitted(state: unknown): ReportSubmitted | null {
  if (typeof state !== 'object' || state === null) return null

  const outer = state as { reportSubmitted?: unknown; programmeNeedsAttention?: unknown }
  if (typeof outer.reportSubmitted !== 'object' || outer.reportSubmitted === null)
    return null

  const inner = outer.reportSubmitted as { contract?: unknown; period?: unknown }
  if (typeof inner.contract !== 'string' || typeof inner.period !== 'string')
    return null

  return {
    contract: inner.contract,
    period: inner.period,
    programmeNeedsAttention: outer.programmeNeedsAttention === true
  }
}

type Props = {
  submitted: ReportSubmitted | null
}

function SubmissionNotice(props: Props) {
  if (props.submitted === null) return null

  return (
    <Text className={styles.success}>
      {`Your KPI report for ${props.submitted.period} on ${props.submitted.contract} has been submitted.`}
    </Text>
  )
}

export { SubmissionNotice, readReportSubmitted }
export type { ReportSubmittedState, ReportSubmitted }
